module.exports = __webpack_public_path__ + "img/user-portfolio-mobile.9274138.png";